import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Message, Loader } from 'semantic-ui-react';

import AddButton from '../../components/Button/AddButton';
import Table from '../../components/Table';
import Modal from './Modal';

import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import { Container, Header, Title } from './styles';

import { GET_TELEGRAM_GROUPS } from '../../services/graphql/queries';

const columns = [
  { id: 'group_id', label: 'ID Grupo', minWidth: 100 },
  { id: 'group_name', label: 'Nombre grupo', minWidth: 100 },
  { id: 'mall_name', label: 'Centro comercial', minWidth: 100 },
  { id: 'active', label: 'Activo', minWidth: 100 },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

const generalMall = [{ key: '0', value: '0', text: 'General' }];

export default function Telegram() {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});
  const [mallsOptions, setMallsOptions] = useState([...generalMall]);

  const { loading, error, data, refetch } = useQuery(GET_TELEGRAM_GROUPS);

  useEffect(() => {
    if (data) {
      if (data.getMalls) {
        setMallsOptions(
          data.getMalls.filter((data, index) => index !== 0).map(mall => ({
            key: mall.id,
            text: `${mall.name} - ${mall.code}`,
            value: mall.id,
            country_id: mall.country_id
          }))
        );
      }
    }
  }, [data]);

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="telegram-component">
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Telegram</Title>
            <AddButton add onClick={handleAdd} />
          </Header>
          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={data ? data.getTelegramGroups : null}
              columns={columns}
              handleEdit={handleEdit}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            edit={edit}
            selected={selected}
            mallsOptions={[...generalMall, ...mallsOptions]}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
